import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";

@Injectable({ providedIn: "root" })
export class DialogService {
  constructor(
    // public dialog: MatDialog,
    // public snackBar: MatSnackBar,
    private toastr: ToastrService
  ) {}

  // openDialog(width, type, message, buttons?, action?, showCancelButton = true) {
  //     return this.dialog.open(DialogComponent, {
  //         width: (width) ? width : '500px',
  //         data: {
  //             title: (type) ? type : 'Confirm',
  //             showCancelButton,
  //             message: (message) ? message : 'Are you sure?',
  //             buttonText: (buttons) ? buttons : {
  //                 ok: 'YES',
  //                 cancel: 'NO'
  //             },
  //             action: action
  //         }
  //     });
  // }

  showToast(message: string, panelClass?: string, duration: number = 500) {
    setTimeout(() => {
      switch (panelClass) {
        case "success":
          this.toastr.success(message, "Success");
          break;

        case "info":
          this.toastr.info(message, "Info");
          break;
        case "warn":
          this.toastr.warning(message, "Warning");
          break;
        case "error":
          this.toastr.error(message, "Error");
          break;
      }
      // if (panelClass == "success") {
      // }
      // else if (panelClass == "info") {
      //     this.toastr.info(message, "Info");
      // }
      // else if (panelClass == "warn") {
      // }
      // else {
      //     this.toastr.error(message, "Error");
      // }
    }, duration);
  }
}
